import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SinHorariosDisponibles.css';
import ImagenEmbudo from '../../../../public/images/embudo.png';

class SinHorariosDisponibles extends React.Component {
  render() {
    return (
      <div className="col-md-12">
        <div className={`${s.divImagen}`}>
          <img alt="Anterior" src={ImagenEmbudo} />
        </div>
        <div className={`${s.divTexto} col-md-12`}>
          No se encuentran resultados según su criterio de búsqueda.
        </div>
        <div className={`${s.divTexto} col-md-12`}>
          Por favor <strong>modifique los filtros aplicados.</strong>
        </div>
      </div>
    );
  }
}

export default connect(null, null)(withStyles(s)(SinHorariosDisponibles));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/SinHorariosDisponibles/SinHorariosDisponibles.js